import { useAuthenticatedUserQuery } from '@/src/generated/operations/AuthenticatedUser.generated';
import { createQueryHook } from '@/src/integrations/urql/queries';

export const useRootAuthenticatedUser = createQueryHook(useAuthenticatedUserQuery, {
  context: { additionalTypenames: ['UserProfile'] },
  disableFeatureFlagUsage: true,
  issueToastNotifications: false,
  requiresAuthenticatedUser: false,
  responseTransformer: data => data.authenticatedUser,
});
